import { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Bell, BellOff, UserCircle, Save, AlertCircle, CheckCircle2 } from "lucide-react";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [emailNotif, setEmailNotif] = useState(user?.email_notifications !== false);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const save = async () => {
    setErr(null); setMsg(null); setSaving(true);
    try {
      await api.patch("/auth/profile", { name, phone, email_notifications: emailNotif });
      await refresh();
      setMsg("Profil mis à jour");
    } catch (e) { setErr(formatApiError(e)); }
    finally { setSaving(false); }
  };

  const sendTestDigest = async () => {
    setErr(null); setMsg(null);
    try {
      await api.post("/admin/digest/send");
      setMsg("Digest envoyé à votre email !");
    } catch (e) { setErr(formatApiError(e)); }
  };

  if (user?.vendor) {
    return (
      <div data-testid="profile-page" className="max-w-2xl">
        <div className="lc-small-label mb-1">Compte</div>
        <h1 className="display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-3">
          <UserCircle className="w-7 h-7 text-[var(--lc-orange)]" /> Mon profil vendeur
        </h1>
        <div className="lc-card p-5 mt-6 space-y-4" data-testid="vendor-profile-readonly">
          <div><label className="lc-label">Prénom</label><input className="lc-input" value={user.vendor.first_name || ""} disabled /></div>
          <div><label className="lc-label">Nom</label><input className="lc-input" value={user.vendor.last_name || ""} disabled /></div>
          <div><label className="lc-label">Email</label><input className="lc-input" value={user.vendor.email || ""} disabled /></div>
          <div><label className="lc-label">Téléphone</label><input className="lc-input" value={user.vendor.phone || ""} disabled /></div>
        </div>
        <p className="text-xs text-[var(--lc-gray)] mt-3" data-testid="vendor-profile-hint">
          Seul l'administrateur de votre entreprise peut modifier vos coordonnées.
        </p>
      </div>
    );
  }

  return (
    <div data-testid="profile-page" className="max-w-2xl">
      <div className="lc-small-label mb-1">Compte</div>
      <h1 className="display text-3xl sm:text-4xl font-extrabold tracking-tight flex items-center gap-3">
        <UserCircle className="w-7 h-7 text-[var(--lc-orange)]" /> Mon profil
      </h1>

      {err && <div className="my-4 flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm"><AlertCircle className="w-4 h-4 mt-0.5" />{err}</div>}
      {msg && <div className="my-4 flex items-start gap-2 bg-green-50 border border-green-200 text-green-700 px-3 py-2 rounded text-sm"><CheckCircle2 className="w-4 h-4 mt-0.5" />{msg}</div>}

      <div className="lc-card p-5 mt-6 space-y-4">
        <div><label className="lc-label">Email</label><input className="lc-input" value={user?.email || ""} disabled /></div>
        <div><label className="lc-label">Nom</label><input data-testid="profile-name" className="lc-input" value={name} onChange={(e) => setName(e.target.value)} /></div>
        <div><label className="lc-label">Téléphone</label><input data-testid="profile-phone" className="lc-input" value={phone} onChange={(e) => setPhone(e.target.value)} /></div>
      </div>

      {user?.role === "admin" && (
        <div className="lc-card p-5 mt-4">
          <div className="lc-small-label mb-3">Notifications email</div>
          <label className="flex items-center gap-3 cursor-pointer">
            <input type="checkbox" data-testid="profile-email-notif" checked={emailNotif} onChange={(e) => setEmailNotif(e.target.checked)} />
            <div className="flex-1">
              <div className="text-sm font-semibold flex items-center gap-2">
                {emailNotif ? <Bell className="w-4 h-4 text-[var(--lc-orange)]" /> : <BellOff className="w-4 h-4 text-[var(--lc-gray)]" />}
                Recevoir les emails admin
              </div>
              <p className="text-xs text-[var(--lc-gray)] mt-0.5">Alertes "nouvelle demande validée" + synthèse hebdo du vendredi 17h.</p>
            </div>
          </label>
          <button onClick={sendTestDigest} data-testid="profile-test-digest" className="lc-btn-secondary lc-btn-sm mt-4">Envoyer un digest test maintenant</button>
        </div>
      )}

      <button onClick={save} disabled={saving} data-testid="profile-save" className="lc-btn-primary mt-4"><Save className="w-4 h-4" /> {saving ? "Enregistrement…" : "Enregistrer"}</button>
    </div>
  );
}
